import repository from '@/repositories/Repository'

const resource = '/api/query-log'

/**
 * PFVデータリポジトリ
 */
export default {
  getMenuGrid() {
    return repository.giggle.get(`${resource}/grid/menu`).then(r => r.data)
  },
  getAccountGrid() {
    return repository.giggle.get(`${resource}/grid/account`).then(r => r.data)
  },
  getAccountAndIpGrid() {
    return repository.giggle
      .get(`${resource}/grid/account_and_ip`)
      .then(r => r.data)
  },
  getMenuRows() {
    return repository.giggle.get(`${resource}/menu/fetch`).then(r => r.data)
  },
  /**
   *
   * @param {*} menuCode
   */
  getAccountRows(menuCode) {
    return repository.giggle
      .get(`${resource}/account/fetch/${menuCode}`)
      .then(r => r.data)
  },
  getAccountAndIpRows(year, month) {
    return repository.giggle
      .get(`${resource}/account_and_ip/${year}/${month}`)
      .then(r => r.data)
  },
  /**
   * 分析履歴のデータを取得
   */
  getQueryHistoryRows(immediate, reserve) {
    return repository.giggle
      .get(`${resource}/fetch/query-history`, {
        params: {
          immediate,
          reserve,
        },
      })
      .then(r => r.data)
  },
  /**
   * 分析履歴の分析条件データ（単体）を取得
   */
  getQueryFilter(queryId) {
    return repository.giggle
      .get(`${resource}/fetch/query-history/${queryId}`)
      .then(r => r.data)
  },
}
